module.exports = "/assets/about/success/fsnw.png?3q7Au8G";